import React from 'react';

import useReportQueryParams from '../../../hooks/use-report-query-params';
import OverallCards from './OverallCards';
import ProgressCards from './ProgressCards';
import ErrorAnalysisCards from './ErrorAnalysisCards';

const WdtStudentReport: React.FC = () => {
  const [reportParams] = useReportQueryParams();

  if (!reportParams.entityId) return null;

  return (
    <>
      <OverallCards />
      <ProgressCards />
      <ErrorAnalysisCards />
    </>
  );
};

export default WdtStudentReport;
